import { Link } from 'react-router-dom';
import { ArrowLeft, Store, Sparkles } from 'lucide-react';

import { Navbar } from '../../../components/Navbar.jsx';
import { RegistroComercianteForm } from './RegistroComercianteForm.jsx';

// --- FONDO AMBIENTAL ---
const AmbientBackground = () => (
  <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none bg-[#020202]">
    <div className="absolute top-[-10%] left-[-10%] w-[50vw] h-[50vw] bg-emerald-900/20 rounded-full blur-[150px] opacity-30 mix-blend-screen animate-pulse" />
    <div className="absolute bottom-[-10%] right-[-10%] w-[60vw] h-[60vw] bg-teal-900/10 rounded-full blur-[150px] opacity-20 mix-blend-screen" />
  </div>
);

export function RegistroTiendaPage() {
  return (
    <div className="h-screen w-full text-slate-200 font-sans selection:bg-emerald-500/30 flex flex-col overflow-hidden">
      <AmbientBackground />
      
      {/* Navbar fija */}
      <div className="flex-shrink-0 z-50">
        <Navbar />
      </div>

      {/* Contenedor Principal Centrado (Sin scroll) */}
      <main className="flex-1 flex items-center justify-center px-4 relative">
        
        <div className="w-full max-w-4xl relative z-10">
          
          {/* Botón Volver pegado a la tarjeta */}
          <div className="mb-3">
            <Link
              to="/"
              className="group inline-flex items-center gap-2 text-[10px] font-bold uppercase tracking-widest text-white/40 hover:text-white transition-colors"
            >
              <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" /> Volver al inicio
            </Link>
          </div>

          {/* TARJETA PRINCIPAL */}
          <div className="rounded-[2rem] border border-white/10 bg-[#0F0F0F]/80 backdrop-blur-xl shadow-2xl overflow-hidden relative">
            
            {/* Decoración superior */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-emerald-500/50 to-transparent opacity-50" />

            <div className="grid lg:grid-cols-5 gap-0">
                
                {/* COLUMNA IZQUIERDA: Branding (2/5 del ancho) */}
                <div className="hidden lg:flex lg:col-span-2 bg-white/[0.02] border-r border-white/5 p-8 flex-col justify-center relative overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-b from-emerald-500/10 to-transparent opacity-30" />
                    
                    <div className="relative z-10">
                        <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-500/20 to-teal-500/10 border border-emerald-500/20 flex items-center justify-center mb-5 shadow-[0_0_20px_rgba(16,185,129,0.2)]">
                            <Store className="w-6 h-6 text-emerald-400" />
                        </div>
                        <h1 className="text-2xl font-bold text-white tracking-tight leading-tight mb-3">
                            Tu Negocio, <br/> Siguiente Nivel.
                        </h1>
                        <p className="text-white/50 text-xs leading-relaxed mb-6">
                            Plataforma todo en uno para comercio digital. Configuración inmediata.
                        </p>

                        <div className="space-y-3">
                            <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-wider text-emerald-400/80">
                                <Sparkles className="w-3 h-3" /> Prueba gratuita 15 días
                            </div>
                            <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-wider text-emerald-400/80">
                                <Sparkles className="w-3 h-3" /> Sin tarjeta de crédito
                            </div>
                        </div>
                    </div>
                </div>

                {/* COLUMNA DERECHA: Formulario (3/5 del ancho) */}
                <div className="col-span-5 lg:col-span-3 p-6 md:p-8 flex flex-col justify-center">
                   <div className="lg:hidden mb-4 flex items-center gap-3">
                        <Store className="w-5 h-5 text-emerald-400" />
                        <h2 className="text-lg font-bold text-white">Crear Tienda</h2>
                   </div>

                   {/* El formulario */}
                   <RegistroComercianteForm />
                
                </div>
            </div>

          </div>
        </div>
      </main>
    </div>
  );
}